import { Injectable } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';

@Injectable()
export class UserblockService {
    public userBlockVisible: boolean;
    constructor(
        private settings: SettingsService
    ) {
        // initially visible
        this.userBlockVisible = this.settings.getLayoutSetting('hideSidebarUserBlock');
    }

    getVisibility() {
        return this.userBlockVisible;
    }

    setVisibility(stat = true) {
        this.userBlockVisible = stat;
    }

    toggleVisibility() {
        this.userBlockVisible = !this.userBlockVisible;
        this.settings.setLayoutSetting('hideSidebarUserBlock', this.userBlockVisible);
    }

}
